<template>
  <admin-layout :title="$t('create_x', { x: $t('Tax Rate') })">
    <tec-form-section @submitted="submit">
      <template #title>{{ $t('create_x', { x: $t('Tax Rate') }) }}</template>
      <template #description>{{ $t('Please fill the form below to add new record.') }}</template>

      <template #form>
        <div class="col-span-full lg:col-span-4 grid gap-6">
          <text-input v-model="form.name" :error="$page.props.errors.name" :label="$t('Name')" />
          <text-input type="number" v-model="form.rate" :error="$page.props.errors.rate" :label="$t('Rate')" />
          <div class="col-span-6 sm:col-span-4 lg:col-span-4">
            <select-input v-model="form.type" :error="$page.props.errors.type" :label="$t('Type')">
              <option value="Percentage">{{ $t('Percentage') }}</option>
              <option value="Fixed">{{ $t('Fixed') }}</option>
            </select-input>
          </div>
        </div>
      </template>

      <template #actions>
        <tec-action-message :on="form.recentlySuccessful" class="mr-3">{{ $t('Saved.') }}</tec-action-message>
        <loading-button :loading="form.processing" :disabled="form.processing">{{ $t('Save') }}</loading-button>
      </template>
    </tec-form-section>
  </admin-layout>
</template>

<script>
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import AdminLayout from '@/Layouts/AdminLayout';
import LoadingButton from '@/Shared/LoadingButton';
import TecFormSection from '@/Jetstream/FormSection';
import TecActionMessage from '@/Jetstream/ActionMessage';
import TecSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
  components: {
    TextInput,
    AdminLayout,
    SelectInput,
    LoadingButton,
    TecFormSection,
    TecActionMessage,
    TecSecondaryButton,
  },

  data() {
    return {
      form: this.$inertia.form({ _method: 'POST', name: null, rate: null, type: 'Percentage' }),
    };
  },

  methods: {
    submit() {
      this.form.post(route('tax_rates.store'), { preserveScroll: true });
    },
  },
};
</script>
